<div
  class="flex flex-column justify-center align-center h-100 text-center family-info"
  *ngIf="viewToshow == ''"
>
  <div class="modal-icon">
    <img src="../../../../assets/images/svgs/information_1.svg" alt="ICON"/>
  </div>
  <h1 class="para-title">Before we begin</h1>
  <h5 class="" style="margin: 10px 0; font-weight: 500;">
    You will need the following information:
  </h5>
  <p class="para-body">
    <span class="block-element">1. Name of child</span>
    <span class="block-element">2. Class of child</span>
    <span class="block-element">3. Tuition fees</span>
  </p>

  <button
    class="ui button primary basic mt-4"
    (click)="viewToshow = 'selectChildren'; previousPage.emit('')"
  >
    Continue
  </button>
</div>

<!-- <div class="identifyOrAnonymous flex flex-column align-center">
  <div
    class="flex flex-column align-center"

  >
    <p class="para-title text-center mt-4 mb-4">
      This information will help us when sending our gratitude notification
    </p>
  </div> -->

<!-- <small class="smallNotification" *ngIf="notification?.show">
    {{ notification?.message }}
  </small> -->
<!-- </div> -->

<div
  class=" h-100 text-center family-info"
  *ngIf="viewToshow == 'selectChildren'"
>
  <h1 class="para-title">How many children do you have?</h1>

  <div class="ui grid justify-center" style="overflow: hidden; margin: 0 auto;">
    <div
      (click)="selectThis($event)"
      class="six wide column myborder positioned-relative"
    >
      <img src="../../../assets/images/svgs/user.svg" alt=""/>
      <p class="bolded">1</p>
      <i *ngIf="selected == '1'" class="fa fa-check positioned-absolute"></i>
    </div>

    <div
      (click)="selectThis($event)"
      class="six wide column myborder positioned-relative"
    >
      <img
        src="../../../assets/images/svgs/user2.svg"
        style="max-width: 50px;"
        alt=""
      />
      <p class="bolded">2</p>
      <i *ngIf="selected == '2'" class="fa fa-check positioned-absolute"></i>
    </div>

    <div
      (click)="selectThis($event)"
      class="six wide column myborder positioned-relative"
    >
      <img
        src="../../../assets/images/svgs/user4.svg"
        style="max-width: 50px;"
        alt=""
      />
      <p class="bolded">3</p>
      <i *ngIf="selected == '3'" class="fa fa-check positioned-absolute"></i>
    </div>

    <div
      (click)="selectThis($event)"
      class="six wide column myborder positioned-relative"
    >
      <img
        src="../../../assets/images/svgs/user6.svg"
        alt=""
        style="max-width: 67px;"
      />
      <p class="bolded">3+</p>
      <i *ngIf="selected == '3+'" class="fa fa-check positioned-absolute"></i>
    </div>
  </div>

  <!-- <button
    [disabled]="numberOfSelected"
    (click)="startEnteringChildInfo()"
    class="ui button primary basic mt-4"
  >
    Continue
  </button> -->
</div>


<div
  class=" h-100 text-center family-info"
  *ngIf="viewToshow == 'enterChildCount'"
>
  <h1 class="para-title">Please enter the number of children</h1>

  <form class="w-100">
    <div class="ui form">
      <div class="field">
        <label>Number</label>
        <input [(ngModel)]="countOfChild" name="countOfChild" type="number" placeholder="Fullname"/>

      </div>


    </div>

    <div class="text-center mt-4">
      <button
        [disabled]="countOfChild < 1"
        type="button"
        class="ui primary button fluid"
        (click)="addCountOfChild()"
      >
        Continue
      </button>
    </div>
  </form>


</div>

<div
  class=" h-100 text-center family-info"
  *ngIf="viewToshow == 'select-funding-type'"
>
  <h1 class="para-title">Please select what you need funding for</h1>

  <div class="ui grid justify-center" style="overflow: hidden; margin: 0 auto;">
    <div
      (click)="selectTypeOfFunding($event)"
      class="six wide column myborder positioned-relative"
      id="tuition"
    >
      <img src="../../../assets/images/fees_modified.svg" alt=""/>
      <p class="bolded">Tuition</p>
      <i *ngIf="typeOffundingArr.has('tuition')" class="fa fa-check positioned-absolute"></i>
      <div *ngIf="keysNotToFunding.has('tuition')" class="padlock">
        <img src="../../../assets/images/padlock.svg" alt="">
      </div>
    </div>

    <div
      (click)="selectTypeOfFunding($event)"
      class="six wide column myborder positioned-relative"
      id="transport"
    >
      <img
        src="../../../assets/images/bus_modified.svg"
        style="max-width: 50px;"
        alt=""
      />
      <p class="bolded">Transport</p>
      <i *ngIf="typeOffundingArr.has('transport')" class="fa fa-check positioned-absolute"></i>
      <div class="padlock" *ngIf="keysNotToFunding.has('transport')">
        <img src="../../../assets/images/padlock.svg" alt="">
      </div>
    </div>

    <div
      (click)="selectTypeOfFunding($event)"
      class="six wide column myborder positioned-relative"
      id="feeding"
    >
      <img
        src="../../../assets/images/box_modified.svg"
        style="max-width: 50px;"
        alt=""
      />
      <p class="bolded">Feeding</p>
      <i *ngIf="typeOffundingArr.has('feeding')" class="fa fa-check positioned-absolute"></i>
      <div class="padlock" *ngIf="keysNotToFunding.has('feeding')">
        <img src="../../../assets/images/padlock.svg" alt="">
      </div>
    </div>

    <!--    <div-->
    <!--      (click)="selectTypeOfFunding($event)"-->
    <!--      class="six wide column myborder positioned-relative"-->
    <!--      id="uniform"-->
    <!--    >-->
    <!--      <img-->
    <!--        src="../../../assets/images/uniform_modified.svg"-->
    <!--        alt=""-->
    <!--        style="max-width: 50px;"-->
    <!--      />-->
    <!--      <p class="bolded">Uniform</p>-->
    <!--      <i *ngIf="typeOffundingArr.has('uniform')" class="fa fa-check positioned-absolute"></i>-->
    <!--      <div class="padlock" *ngIf="keysNotToFunding.has('uniform')">-->
    <!--        <img src="../../../assets/images/padlock.svg" alt="">-->
    <!--      </div>-->
    <!--    </div>-->

    <button
      class="ui button primary basic mt-4"
      *ngIf="typeOffundingArr.size > 0"
      (click)="calculateKeyFundingAreas()"
    >
      Continue
    </button>
  </div>

  <!-- <button
    [disabled]="numberOfSelected"
    (click)="startEnteringChildInfo()"
    class="ui button primary basic mt-4"
  >
    Continue
  </button> -->
</div>

<div
  class=" h-100 text-center family-info"
  *ngIf="viewToshow == 'enterInformation'"
>
  <h1 class="para-title">
    {{
    mapOfChildrensInfo.size == 1
      ? "Enter child's Information"
      : "Enter " + currentChild + " child's information"
    }}
  </h1>

  <form [formGroup]="childInfoForm" class="w-100">
    <div class="ui form">
      <div class="field">
        <label>First Name</label>
        <input formControlName="first_name" type="text" placeholder="Fullname"/>

      </div>

      <div class="field">
        <label>Last Name</label>
        <input formControlName="last_name" type="text" placeholder="Last Name"/>

      </div>
      <!-- <div class="field">


        <div class="field">
          <label>Class</label>
          <input
            name="class"
            formControlName="class"
            type="text"
            placeholder="Class of child eg: JSS 1"
          />
        </div>
      </div> -->

      <div class="field">
        <label>Class</label>
        <!-- (change)="updateTuitionValidations($event.target.value)" -->
        <select
          style="height: auto;"
          class="ui fluid search dropdown"
          formControlName="class"
          (change)="updateTuitionValidations($event.target.value)"
        >
          <option value="" selected>Select class...</option>
          <option
            [value]="class.id"
            *ngFor="let class of schoolClasses; index as i"
          >
            {{ class.name }}
          </option>
        </select>
      </div>

      <div
        [style.display]="parentNeedsToEnterTuition ? 'block':'none'"
        class="field positioned-relative">
        <label>Tuition fees </label>
        <input
          formControlName="tuition_fees"
          name="tuition"
          type="tel"
          #inputForTuition
          (change)="generalservice.makeReadable($event.target.value, inputForTuition)"
          placeholder="Enter tuition fees"

        />
        <!-- <small
          *ngIf="childInfoForm.get('tuition_fees').value"
          class="positioned-absolute currency"
        >
          &#8358;
        </small> -->
        <!-- <div *ngIf="phone.touched && phone.invalid" class="ng-invalid ng-touched">
            <small style="color: #f10b0b9d;" *ngIf="phoneIsRequired()">
              Your phone number is required!</small>
          </div> -->
      </div>
    </div>
    <!-- {{ iterator.next().done }} {{ iterator.next() }} -->
    <div class="text-center mt-4">
      <button
        [disabled]="!childInfoForm.valid"
        type="submit"
        class="ui primary button fluid"
        (click)="carryOn()"
      >
        Continue
      </button>
    </div>
  </form>
</div>

<div *ngIf="viewToshow == 'upload-image'" style="position: relative">
  <h1 class="para-title text-center mb-3">
    Click the image to add child's picture
  </h1>

  <app-picture
    [fromWhere]="'child-information-form'"
    (childPicture)="saveChildPictureFromPictureComp($event)"
    (changeUpTheView)="showBookSelectionPage()"
  ></app-picture>
</div>

<div style="margin-top: 30px;" *ngIf="viewToshow == 'select-books'">
  <app-school-books
    (goback)="goToBooksPage($event)"
    (previousPageInSchool)="schoolBookPages = $event"
    [nextOrPrev]="schoolBookPages"
    (skip)="parentSkippedBooksSelection()"
    (selectionComplete)="childBooksHasBeenAdded($event)"></app-school-books>
</div>

<div class=" h-100 text-center family-info" *ngIf="viewToshow == 'modifyOrNot'">
  <h1 class="para-title">
    You just provided details for
    {{ nameOfRecentlyAddedChild }}
  </h1>

  <button
    (click)="modifyPreviouslyEnteredChildInfo()"
    class="ui button primary basic mt-4"
  >
    Edit
  </button>

  <button
    (click)="onToNextChild($event.target.textContent)"
    class="ui button primary basic mt-4"
  >
    {{ currentChild ? "Continue to " + currentChild + " child" : "Next" }}
  </button>
</div>

<div
  class="flex flex-column justify-center align-center h-100 text-center family-info"
  *ngIf="viewToshow == 'summary'"
  style="position: relative"
>
  <h1 class="para-title">Do you have any more children to enter?</h1>
  <div class="w-100 flex justify-center align-center">
    <button (click)="parentWantsToAddMoreChildren()" class="ui button primary basic mt-4 mr-2">
      Yes
    </button>

    <button (click)="doneAddingChildren()" class="ui button primary basic mt-4">
      No
    </button>
  </div>
  <div *ngIf="spinner" class="spinner-container">
    <!-- <i class="fa fa-circle-notch fa-spin fa-3x"></i> -->
    <app-loader></app-loader>
  </div>
</div>


<!-- [currentChild]="currentChildForWhichBookIsBeingSelected"  -->
